export default {"src":"/_next/static/media/home_location_Icon.1be384f2.svg","height":29,"width":31,"blurWidth":0,"blurHeight":0};